import React from 'react';
import { Helmet } from 'react-helmet-async';
import { defaultSEOConfig } from '../utils/seo';

const SEO = () => {
  return (
    <Helmet>
      <title>{defaultSEOConfig.title}</title>
      <meta name="description" content={defaultSEOConfig.description} />
      <meta name="keywords" content={defaultSEOConfig.keywords} />
      <link rel="canonical" href={defaultSEOConfig.url} />
      
      {/* Open Graph / Social Media */}
      <meta property="og:site_name" content={defaultSEOConfig.siteName} />
      <meta property="og:locale" content={defaultSEOConfig.locale} />
      <meta property="og:type" content={defaultSEOConfig.openGraph.type} />
      <meta property="og:title" content={defaultSEOConfig.openGraph.title} />
      <meta property="og:description" content={defaultSEOConfig.openGraph.description} />
      <meta property="og:url" content={defaultSEOConfig.url} />
      <meta property="og:image" content={defaultSEOConfig.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content={defaultSEOConfig.twitter.card} />
      <meta name="twitter:title" content={defaultSEOConfig.twitter.title} />
      <meta name="twitter:description" content={defaultSEOConfig.twitter.description} />
      <meta name="twitter:image" content={defaultSEOConfig.image} />
    </Helmet>
  );
};

export default SEO;